<ol class="steps p-0 mb-0 is-vertical" [ngClass]="{ 'steps-line': showLine }">
  <ng-content />
</ol>
